import React, { createContext, useContext, useState, useEffect } from 'react';
import http from '../lib/api';

const DEFAULT = {
  demoMode: false,
  allowDemoLogin: false,
  contact: {
    companyName: 'Xpertpests Solutions',
    email: 'info@xpertpestssolutions.com',
    phone1: '562-215-8002',
    phone2: '310-629-9049',
    website: 'www.xpertpestssolutions.com',
    address: 'P.O. Box 4462, Carson, CA 90745',
    tagline: 'Real Results, Forget the Rest!',
  },
};

const ConfigContext = createContext(DEFAULT);
export const useConfig = () => useContext(ConfigContext);

export function ConfigProvider({ children }) {
  const [cfg, setCfg] = useState(DEFAULT);
  useEffect(() => {
    http.get('/config')
      .then(r => setCfg({ ...DEFAULT, ...r.data, contact: { ...DEFAULT.contact, ...(r.data.contact || {}) } }))
      .catch(() => {});
  }, []);
  return <ConfigContext.Provider value={cfg}>{children}</ConfigContext.Provider>;
}
